import { useState } from "react";
import { Alert, Button, Table } from "antd";
import { useTranslation } from "react-i18next";
import { Page } from "shared/ui";
import { TaskExecution, useGetMyTaskExecutionsQuery } from "shared/api";
import { flattenMyTaskExecutions } from "shared/helpers";
import { useCompleteMyTasksColumns } from "shared/hooks";
import { CompleteTaskModal } from "./CompleteTaskModal";

const CompleteMyTasks = () => {
  const { t } = useTranslation();

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, isLoading, isFetching, isError, refetch } =
    useGetMyTaskExecutionsQuery();

  const onCompleteTask = (record: TaskExecution) => {
    setSelectedId(record.id);
    setIsModalOpen(true);
  };

  const columns = useCompleteMyTasksColumns({ onCompleteTask });

  const rows = data?.my_task_executions
    ? flattenMyTaskExecutions(data.my_task_executions)
    : [];

  return (
    <Page
      title={t("taskHub.myTasks.completeMyTasksTitle") || "Complete my tasks"}
    >
      {isError ? (
        <Alert
          className="mt-4"
          type="error"
          showIcon
          message={
            t("taskHub.myTasks.loadError") || "Failed to load your tasks"
          }
          description={
            t("taskHub.myTasks.loadErrorDescription") ||
            "Something went wrong while loading your task executions."
          }
          action={
            <Button size="small" danger onClick={() => refetch()}>
              {t("Retry") || "Retry"}
            </Button>
          }
        />
      ) : (
        <Table<TaskExecution>
          className="mt-4"
          columns={columns}
          dataSource={rows}
          rowKey={(record) => record.id}
          loading={isLoading || isFetching}
          pagination={{ pageSize: 20, showSizeChanger: true }}
        />
      )}

      <CompleteTaskModal
        open={isModalOpen}
        taskExecutionId={selectedId}
        onClose={() => setIsModalOpen(false)}
      />
    </Page>
  );
};

export { CompleteMyTasks };
